var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('navbar',{attrs:{"title":"查看证书","back":true}}),_c('canvas',{staticClass:"my-canvas",attrs:{"id":"mycanvas"}}),_c('img',{staticClass:"img",attrs:{"src":_vm.image},on:{"click":_vm.Flag}}),_c('div',{class:_vm.mymoveState?'float':'float-reverse'},[_vm._v(" 长按图片可保存到本地 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }